import type {
  CampaignRankingRow,
  CampaignRankingScope
} from '../types/campaign'

import { cn } from '@/shared/lib/utils'

interface CampaignUserRankBannerProps {
  currentUser: CampaignRankingRow
  scope: CampaignRankingScope
}

const SCOPE_LABELS: Record<CampaignRankingScope, string> = {
  global: 'no ranking geral',
  friends: 'entre amigos',
  link: 'no seu código'
}

export function CampaignUserRankBanner({
  currentUser,
  scope
}: CampaignUserRankBannerProps) {
  const scopeLabel = SCOPE_LABELS[scope]

  return (
    <div
      className={cn(
        'rounded-2xl px-4 py-4 text-center',
        'bg-[linear-gradient(180deg,#FFF4D6_0%,#FFD9A8_100%)]',
        'shadow-[0_4px_0_-1px_#c75300,inset_0_3px_0_0_rgba(255,255,255,0.45)]'
      )}
    >
      <div className="flex items-center justify-center gap-2">
        <img src="/icons/medal-gold.svg" alt="" className="size-8" aria-hidden />
        <p className="text-sm font-semibold uppercase tracking-wide text-[#974319]">
          Sua posição {scopeLabel}
        </p>
      </div>
      <p className="mt-2 font-sans text-4xl font-bold text-[#00298F]">
        #{currentUser.position}
      </p>
      <p className="mt-1 text-lg font-bold text-[#0063E5]">
        {currentUser.points} pontos
      </p>
    </div>
  )
}
